import React from "react";

const ExpieredHistoryList = ({ data = [] }) => {

  const getStatusDisplay = (item) => {
    const status = item.status?.toUpperCase();
    
    if (status === "CANCELLED") {
      return {
        label: "🟡 Cancelled",
        className: "cancelled",
        isUpgrade: false,
      };
    }

    if (status === "EXPIRED") {
      return {
        label: "🔴 Expired",
        className: "expired",
        isUpgrade: false,
      };
    }

    if (status === "ACTIVE") {
      return {
        label: "🟢 Active",
        className: "active",
        isUpgrade: false,
      };
    }

    const statusMap = {
      PENDING: { label: "🟠 Pending", className: "pending" },
      APPROVED: { label: "✅ Approved", className: "approved" },
      REJECTED: { label: "❌ Rejected", className: "rejected" },
    };

    return statusMap[status] || { label: status || "Unknown", className: "" };
  };

  const formatDate = (date) => {
    if (!date) return "-";
    return new Date(date).toLocaleDateString();
  };

  return (
    <div className="premium-user-list-wrapper">
      <div className="premium-scroll-container">

        {data?.map((item, index) => {
          const statusDisplay = getStatusDisplay(item);
          const isUpgraded = item.isUpgrade === true;
          const isCancelled = item.status?.toUpperCase() === "CANCELLED";
          const isExpired = item.status?.toUpperCase() === "EXPIRED";

          return (
            <div key={item._id || index} className="premium-table-row">

              {/* USER - 24% */}
              <div style={{ width: "24%" }}>
                <div className="user-box">
                  <img
                    src={item.userId?.profileImageURL || "/default-avatar.png"}
                    alt="user"
                    className="user-avatar"
                  />
                  <div>
                    <div className="plan-title">
                      {item.userId?.name || "Unknown User"}
                    </div>
                    <div className="plan-desc">
                      {item.userId?.email || "No email"}
                    </div>
                  </div>
                </div>
              </div>

              {/* PLAN - 20% */}
              <div style={{ width: "20%" }}>
                <div className="plan-title">{item.planId?.title}</div>
                <div className={`plan-type ${item.planId?.type?.toLowerCase()}`}>
                  {item.planId?.type}
                </div>
              </div>

              {/* ✅ UPGRADED DETAILS - 18% (New Column) */}
              <div style={{ width: "18%" }}>
                {isUpgraded ? (
                  <div className="upgraded-details">
                    <div className="upgrade-badge">⬆ Upgraded</div>
                    {item.previousPlanTitle && (
                      <div className="previous-plan">
                        From: {item.previousPlanTitle}
                      </div>
                    )}
                    {item.upgradedAt && (
                      <div className="upgrade-date">
                        On: {formatDate(item.upgradedAt)}
                      </div>
                    )}
                    {item.source === "ADMIN_UPGRADE" && (
                      <div className="upgrade-source">By: Admin</div>
                    )}
                  </div>
                ) : (
                  <div className="no-upgrade">—</div>
                )}
              </div>

              {/* ✅ STATUS - 15% (Only status, no extra info) */}
              <div style={{ width: "15%" }}>
                <span className={`status-badge ${statusDisplay.className}`}>
                  {statusDisplay.label}
                </span>
                {isCancelled && (
                  <div className="status-sub">by user</div>
                )}
                {isExpired && (
                  <div className="status-sub">auto</div>
                )}
              </div>

              {/* DATE - 23% */}
              <div style={{ width: "23%" }} className="plan-desc">
                <div>
                  Start: {item.purchaseDate ? formatDate(item.purchaseDate) : "-"}
                </div>
                <div style={{ fontSize: "11px", color: "#aaa" }}>
                  Expiry: {
                    item.expiryDate
                      ? formatDate(item.expiryDate)
                      : "Lifetime"
                  }
                </div>
              </div>

            </div>
          );
        })}
      </div>

      <style>{`
        .premium-table-row {
          display: flex;
          padding: 18px 16px;
          border-bottom: 1px solid rgba(255,255,255,0.05);
          align-items: center;
          flex-wrap: wrap;
        }

        .premium-table-row:hover {
          background: rgba(255,255,255,0.02);
        }

        .plan-title {
          color: #fff;
          font-weight: 600;
          font-size: 14px;
        }

        .plan-desc {
          color: #cbd5f5;
          font-size: 13px;
        }

        .user-box {
          display: flex;
          align-items: center;
          gap: 10px;
        }

        .user-avatar {
          width: 36px;
          height: 36px;
          border-radius: 50%;
          object-fit: cover;
          border: 2px solid rgba(255,255,255,0.1);
        }

        .plan-type {
          font-size: 11px;
          margin-top: 4px;
          display: inline-block;
          padding: 2px 8px;
          border-radius: 10px;
        }

        .plan-type.free {
          background: rgba(255,255,255,0.1);
          color: #ccc;
        }

        .plan-type.pro {
          background: rgba(59,130,246,0.2);
          color: #3b82f6;
        }

        .plan-type.ambassador {
          background: rgba(251,191,36,0.2);
          color: #facc15;
        }

        /* ✅ Upgraded Details Column */
        .upgraded-details {
          display: flex;
          flex-direction: column;
          gap: 2px;
        }

        .upgrade-badge {
          font-size: 11px;
          color: #3b82f6;
          background: rgba(59,130,246,0.1);
          padding: 2px 10px;
          border-radius: 10px;
          display: inline-block;
          width: fit-content;
        }

        .previous-plan {
          font-size: 10px;
          color: rgba(255,255,255,0.4);
        }

        .upgrade-date {
          font-size: 10px;
          color: rgba(255,255,255,0.3);
        }

        .upgrade-source {
          font-size: 10px;
          color: rgba(59,130,246,0.4);
        }

        .no-upgrade {
          color: rgba(255,255,255,0.15);
          font-size: 14px;
          text-align: center;
        }

        /* ✅ Status Badges - Clean, only status */
        .status-badge {
          padding: 4px 12px;
          border-radius: 20px;
          font-size: 12px;
          font-weight: 500;
          display: inline-block;
        }

        .status-badge.active {
          background: rgba(34,197,94,0.15);
          color: #22c55e;
        }

        .status-badge.expired {
          background: rgba(239,68,68,0.15);
          color: #ef4444;
        }

        .status-badge.cancelled {
          background: rgba(245,158,11,0.15);
          color: #f59e0b;
        }

        .status-badge.pending {
          background: rgba(245,158,11,0.2);
          color: #f59e0b;
        }

        .status-badge.approved {
          background: rgba(34,197,94,0.2);
          color: #22c55e;
        }

        .status-badge.rejected {
          background: rgba(239,68,68,0.2);
          color: #ef4444;
        }

        .status-sub {
          font-size: 9px;
          color: rgba(255,255,255,0.2);
          margin-top: 2px;
        }

        @media (max-width: 768px) {
          .premium-table-row {
            flex-direction: column;
            align-items: flex-start;
            gap: 8px;
          }

          .premium-table-row > div {
            width: 100% !important;
          }
        }
      `}</style>
    </div>
  );
};

export default React.memo(ExpieredHistoryList);